export default {
  accountOption: '.choose-account-list .choose-account-list__list .choose-account-list__account',
  accountCheckbox: 'input.choose-account-list__list-check-box'
}
